import type { ReactNode } from 'react';

export const symbol_battery_android_frame_share: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M130-240q-37.5 0-63.75-26.25T40-330v-300q0-37.5 26.25-63.75T130-720h642l-61 60H130q-12.75 0-21.37 8.62Q100-642.75 100-630v300q0 12.75 8.63 21.37Q117.25-300 130-300h310q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H130Zm30-90q-12.75 0-21.37-8.63Q130-347.25 130-360v-240q0-12.75 8.63-21.38Q147.25-630 160-630h520l-61 60h-29q-48 0-84 36t-36 84v90q0 12.75-8.62 21.37Q452.75-330 440-330H160Zm378.5-8.63Q530-347.25 530-360v-90q0-24 18-42t42-18h201l-52-53q-8-9-8.5-21t8.5-21q9-9 21-9t21 9l104 104q9 9 9 21t-9 21L782-356q-9.07 9-21.53 9-12.47 0-21.47-9-9-9-9-21t9-21l52-52H590v90q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
